module.exports = __webpack_public_path__ + "static/media/team-member4.7c658276.png";